import { Col, Container, Row } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/Drivers/general/Driversettingsheader.css';

const Driversettingsheader = ({screenName, centered = true}) => {
    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    return (
        <div className="driver-settingsheader-wrapper">
            <Container>
                <Row className="driver-settingsheader">
                    <Col xs={2} className="driver-settingsheader-back-btn-col">
                        <button className="driver-settingsheader-back-btn" onClick={handleBack}>
                            <FaArrowLeft />
                        </button>
                    </Col>
                    <Col xs={8} className="text-center">
                        <h5 className="driver-settingsheader-title">{screenName}</h5>
                    </Col>
                    <Col xs={2}></Col>
                </Row>
            </Container>
        </div>
    );
};
export default Driversettingsheader;